/**
 * مارلين ستور - Shopify Theme JS
 */

(function() {
  'use strict';

  // ===== قائمة الموبايل =====
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const mobileNav = document.getElementById('mobileNav');

  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', function() {
      mobileNav.classList.toggle('is-open');
      const isOpen = mobileNav.classList.contains('is-open');
      this.setAttribute('aria-expanded', isOpen);
    });
  }

  // ===== الكمية (صفحة المنتج) =====
  const qtyMinus = document.getElementById('qty-minus');
  const qtyPlus = document.getElementById('qty-plus');
  const qtyInput = document.getElementById('qty-input');
  const formQty = document.getElementById('form-qty');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) {
        val--;
        qtyInput.value = val;
        if (formQty) formQty.value = val;
      }
    });

    qtyPlus.addEventListener('click', function() {
      let val = parseInt(qtyInput.value) || 1;
      if (val < 99) {
        val++;
        qtyInput.value = val;
        if (formQty) formQty.value = val;
      }
    });
  }

  // ===== معرض صور المنتج =====
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.getElementById('mainProductImage');

  if (thumbs.length && mainImage) {
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        const url = this.dataset.imageUrl;
        if (url) {
          mainImage.src = url;
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          this.classList.add('active');
        }
      });
    });
  }

  // ===== Variant Selection =====
  const variantButtons = document.querySelectorAll('.variant-option');
  const variantIdInput = document.getElementById('variant-id');

  if (variantButtons.length) {
    variantButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const position = this.dataset.optionPosition;
        // Deactivate siblings
        document.querySelectorAll('.variant-option[data-option-position="' + position + '"]').forEach(function(b) {
          b.classList.remove('active');
        });
        this.classList.add('active');
      });
    });
  }
  /*
   * © Daneez | Senior Shopify Developer
   * Custom Theme Architecture • Advanced UX/UI • High Conversion Engineering
   */
  // ===== AJAX إضافة للسلة =====
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (this.querySelector('button[type="submit"]').disabled) return;
      e.stopPropagation();
      const formData = new FormData(this);
      const submitBtn = this.querySelector('button[type="submit"]');
      const originalText = submitBtn.innerHTML;

      submitBtn.disabled = true;
      submitBtn.innerHTML = '⏳ جاري الإضافة...';

      window.MarlenCommerce.addItems([{id:Number(formData.get('id')),quantity:Number(formData.get('quantity') || 1)}])
      .then(function(data) {
        submitBtn.innerHTML = '✅ تمت الإضافة!';
        submitBtn.style.background = '#22c55e';

        // تحديث عداد السلة
        updateCartCount();

        // فتح سلة التسوق الجانبية
        if (typeof refreshCartDrawer === 'function') { refreshCartDrawer(); }
        if (typeof openCartDrawer === 'function') { openCartDrawer(); }

        setTimeout(function() {
          submitBtn.innerHTML = originalText;
          submitBtn.style.background = '';
          submitBtn.disabled = false;
        }, 2000);
      })
      .catch(function(err) {
        window.MarlenCommerce.showError(err.message);
        submitBtn.innerHTML = '❌ حدث خطأ';
        setTimeout(function() {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);
      });
    });
  }

  // ===== تحديث عداد السلة =====
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var countEl = document.getElementById('cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.style.transform = 'scale(1.3)';
          setTimeout(function() {
            countEl.style.transform = 'scale(1)';
          }, 200);
        }
      })
      .catch(function(err) {
        console.error('Cart count error:', err);
      });
  }

  // ===== Smooth Scroll =====
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ===== Header Sticky Shadow =====
  var header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 2px 12px rgba(0,0,0,0.1)';
      } else {
        header.style.boxShadow = '0 1px 4px rgba(0,0,0,0.05)';
      }
    }, { passive: true });
  }

})();
